import modalSelectBranch from './modal-select-branch-b2b-user/modal-select-branch-b2b-user.view.html';
import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';

let inject = [
    '$scope',
    'LoginService',
    '$state',
    '$rootScope',
    'SharedService',
    '$timeout',
    'ngAuthSettings',
    'CartService',
    'SessionService',
    '$uibModal',
    '$mdToast',
    'ByFavoritesService'
];

class LoginController {
    constructor($scope,
        LoginService,
        $state,
        $rootScope,
        SharedService,
        $timeout,
        ngAuthSettings,
        CartService,
        SessionService,
        $uibModal,
        $mdToast,
        ByFavoritesService) {
        this.ByFavoritesService = ByFavoritesService;
        this.$state = $state;
        this.SessionService = SessionService;
        this.activateTab = 0;
        this.ngAuthSettings = ngAuthSettings;
        this.CartService = CartService;
        // this.$scope = $scope;
        this.loadingRpass = false;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.errorLogin = '';
        this.LoginService = LoginService;
        this.$uibModal = $uibModal;
        this.$mdToast = $mdToast;
        this.SharedService = SharedService;
        this.user = {};
        this.newUser = {
            branchCity: ''
        };
        this.documentTypes = [];
        this.restoreAccount = '';
        this.invalidUserOrPass = false;
        this.validateRestore = false;
        this.passwordInvalid = false;
        this.thirdDocumentInvalid = false;
        this.userEmailInvalid = false;
        this.validatingDocument = false;
        this.validatingEmail = false;
        this.validatingLogin = false;
        this.showSelectModal = false;
        this.successMessage = false;
        this.errorMessageRegister = false;
        this.validatingCreateUser = false;
        this.errorRestoringAccount = false;
        this.successRestoringAccount = false;
        this.recoveryPasswordDataLoading = false;
        this.recoveryPasswordDataReceived = false;
        this.recoveryPasswordIsAValidUser = false;
        this.errorRecoveryPassword = '';
        this.active = 0;
        this.loginDataForm = {};
        this.loginDataForm.email = undefined;
        this.recoveryPasswordDataForm = {};
        this.pageName = "PAG-6";
        this.SharedService.getCMSBanners(this.pageName).then(response => {
            this.cmsData = response;
        });

    }

    $onInit() {
        try {
            let userId = this.shCtrl.globals.currentUser.userId;
            this.$state.go(this.ngAuthSettings.site.app.header.logo.url);
        } catch (e) {

        }
    }

    seeLogin() {
        this.rPass = !this.rPass;
    }

    loginUser() {

        if (this.loginForm.$valid) {
            this.errorLogin = '';
            this.dataLoading = true;
            this.validatingLogin = true;
            this.LoginService.login(this.loginDataForm.email, this.loginDataForm.password).then(response => {
                this.validatingLogin = false;
                this.dataLoading = false;
                this.dataReceived = true;
                if (!response.error) {
                    this.isAValidUser = true;
                    let cartId = this.SessionService.get('cartId') || '';
                    let clientPriceListName = '';
                    try {
                        clientPriceListName = this.SessionService.get('quoteCartSeller').clientPriceList;
                    } catch (e) {
                    }

                    this.ByFavoritesService.getResumeProductsFavorites(response.data.userId).then(favoritesResponse => {

                        response.data.favoriteItems = favoritesResponse;

                        this.CartService.getCartResumeData(cartId, response.data.userId, true).then(cartResponse => {

                            this.cart = response;
                            this.SharedService.saveUserLogued(response.data);

                            try {
                                if (/*response.data.isB2B && */response.data.operatingCenters) {

                                    if (/*response.data.isB2B && */response.data.operatingCenters.length > 1) {
                                        this.showSelectModal = true;
                                        this.showModalSelectBranchUserB2B(response.data);
                                        return;
                                    } else if (response.data.operatingCenters.length === 1) {
                                        this.LoginService.setOperatingCenter(response.data.operatingCenters[0].id, response.data.userId)
                                            .then(responseOperatingCenter => {
                                                response.data.operatingCenter = responseOperatingCenter.branch;
                                                response.data.seller = responseOperatingCenter.seller;
                                                this.SharedService.saveUserLogued(response.data);

                                                let newCurrentClient = JSON.parse(global.localStorage.currentClient);
                                                newCurrentClient.operatingCenter = responseOperatingCenter.branch;
                                                newCurrentClient.seller = responseOperatingCenter.seller;
                                                this.SessionService.put('currentClient', newCurrentClient);

                                                if (responseOperatingCenter.validaVolumenCompra) {
                                                    this.SharedService.verifyVolumePurchaseBasket({ 'cartId': responseOperatingCenter.cartID }).then(volumenResponse => {
                                                        if (!volumenResponse.error) {
                                                            if (!volumenResponse.pesoValidoBodega) {
                                                                let idCiudad = response.data.operatingCenter.ciudad_id;
                                                                let idUsuario = response.data.userId;
                                                                this.cambiarSucursalVolumenItems(responseOperatingCenter.cartID, idCiudad, idUsuario);
                                                            }
                                                        }
                                                    });
                                                }
                                            }).catch(reason => {
                                            });
                                    }
                                }

                                // if (response.data.isB2B) this.$state.go('home.salesHome');
                                if (response.data.isB2B) {
                                    this.$state.go('home.salesHome');
                                    this.$rootScope.reloadProyect = true;
                                    // this.$rootScope.reloadProyectState = this.ngAuthSettings.site.app.header.logo.url;
                                    // this.$rootScope.reloadProyectState = 'home.salesHome';
                                    this.$rootScope.reloadProyectState = this.$rootScope && this.$rootScope.componentToRedirect ? this.$rootScope.componentToRedirect :  'home.salesHome';
                                    this.$state.reload();
                                }
                                else {
                                    if (this.ngAuthSettings.site.config.redirectToB2bPage &&
                                        (response.data.isSeller || response.data.isContactCenter)) {
                                        this.$rootScope.reloadProyect = true;
                                        this.$rootScope.reloadProyectState = 'home.contactCenterHome';
                                        this.$state.reload();
                                        // this.$state.go('home.contactCenterHome');
                                        return;
                                    }
                                    if (cartResponse) {
                                        if (cartResponse.items.length > 0) {
                                            this.$rootScope.reloadProyect = true;
                                            this.$rootScope.reloadProyectState = 'home.cart';
                                            this.$state.reload();
                                            // this.$state.go('home.cart');
                                        }
                                        else {
                                            // this.$state.go(this.ngAuthSettings.site.app.header.logo.url);
                                            // this.$timeout(() => {this.$state.reload();}, 1000);
                                            this.$rootScope.reloadProyect = true;
                                            this.$rootScope.reloadProyectState = this.ngAuthSettings.site.app.header.logo.url;
                                            this.$state.reload();
                                            // this.$timeout(() => {this.$state.go(this.ngAuthSettings.site.app.header.logo.url);}, 2000);
                                            // return;
                                        }
                                    }
                                    else {
                                        // this.$state.go(this.ngAuthSettings.site.app.header.logo.url);
                                        // this.$timeout(() => {this.$state.reload();}, 1000);
                                        this.$rootScope.reloadProyect = true;
                                        this.$rootScope.reloadProyectState = this.ngAuthSettings.site.app.header.logo.url;
                                        this.$state.reload();
                                        // this.$timeout(() => {this.$state.go(this.ngAuthSettings.site.app.header.logo.url);}, 2000);
                                    }
                                }
                            }
                            catch (e) {
                                alert(e.message);
                                this.$rootScope.reloadProyect = true;
                                this.$rootScope.reloadProyectState = this.ngAuthSettings.site.app.header.logo.url;
                                this.$state.reload();
                            }
                        });

                    });


                } else {
                    this.errorLogin = response.message;
                    this.isAValidUser = false;
                }
            }).catch(() => {
                this.validatingLogin = false;
            });
        }
        else {
            this.userEmpty = true;
            this.passwordEmpty = true;
        }
    }

    showModalSelectBranchUserB2B(userData) {

        let options = {
            userData: {
                currentUser: userData
            },
            branches: userData.operatingCenters,
            currentBranch: null,
            cmsMessage: this.shCtrl.globalParams.cmsInfo
        };
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalSelectBranch,
            controller: 'ModalSelectBranchController',
            controllerAs: 'mdCtrl',
            size: '',
            backdrop: 'static',
            keyboard: false,
            size: 'lg',
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(result => {
            this.showSelectModal = false;
        }).catch(reason => {
            this.showSelectModal = false;
        });
    }

    registerUser() {
        if (this.registerForm.$valid) {
            this.validatingCreateUser = true;
            if (this.newUser.branchCity) this.newUser.branchCityId = this.newUser.branchCity.id;
            this.LoginService.registerUser(this.newUser).then(response => {
                this.validatingCreateUser = false;
                if (!response.error) {
                    this.successMessage = response.message;
                    this.user.email = angular.copy(this.newUser.email);
                    this.newUser = {};
                    this.registerForm.$setPristine();
                    this.$timeout(() => this.activateTab = 0, 7000);
                } else {
                    this.errorMessageRegister = response.message;
                    this.$timeout(() => this.errorMessageRegister = null, 7000);
                }
            }).catch(error => {
                this.validatingCreateUser = false;
            });
        }
    }

    // /**
    //  Set captcha id on create captcha
    //  @method widgetId
    //  @param widgetId captcha widgetr id
    //  */
    // setWidgetId (widgetId)  {
    //   this.captchaId = widgetId;
    // };
    //
    // /**
    //  Set captcha value on enter captcha
    //  @method setResponse
    //  @param response captcha value
    //  */
    // setResponse (response) {
    //   this.enteredCaptcha = true;
    //   this.expiredCaptcha = false;
    //   this.captcha = response;
    // };
    //
    // /**
    //  Expiration captcha event
    //  @method cbExpiration
    //  */
    // cbExpiration () {
    //   this.expiredCaptcha = true;
    //   this.enteredCaptcha = false;
    //
    //   this.captcha = '';
    // };
    //

    validatePassword() {
        if (this.newUser.password && this.newUser.passwordConfirm) {
            if (!angular.equals(this.newUser.password, this.newUser.passwordConfirm)) {
                this.passwordInvalid = true;
            }
        }
    }

    validateThirdDocument() {
        if (this.newUser.thirdDocumentNumber) {
            this.validatingDocument = true;
            this.SharedService.validateThirdDocument(this.newUser.thirdDocumentNumber).then(response => {
                this.validatingDocument = false;
                this.thirdDocumentInvalid = response;
            }).catch(error => {
                this.validatingDocument = false;
            });
        }
    }

    validateEmail() {
        if (this.newUser.email) {
            this.validatingEmail = true;
            this.SharedService.validateEmail(this.newUser.email).then(response => {
                this.validatingEmail = false;
                this.userEmailInvalid = response.error;
            }).catch(error => {
                this.validatingEmail = false;
            });
        }
    }

    restoreAccountByEmail() {
        if (!this.loadingRpass) {

            this.loadingRpass = true;
            this.validateRestore = true;
            this.origen = 'b2b';

            if (this.recoveryPasswordForm.$valid) {
                this.LoginService.resetPassword(this.loginDataForm.email, this.origen).then(response => {
                    this.validateRestore = false;
                    var text = "";
                    let options = {};
                    if (!response.error) {
                        this.active = 0;
                        this.loginDataForm.email = '';
                        this.captchaModel = null;
                        text = "Se ha enviado una nueva clave de acceso a su correo. Por seguridad, te recomendamos cambiar la contraseña la próxima vez que inicies sesión..";
                        options = {
                            title: 'Cambio de clave',
                            isHtml: true,
                            content: `<div class="alert alert-success"> Se ha enviado una nueva clave de acceso a su correo.</div>`,
                            size: '',
                            showBottonCancel: false,
                            textActionCancel: '',
                            textAction: 'Aceptar'
                        };

                    } else {
                        text = response.message;
                        options = {
                            title: 'Cambio de clave',
                            isHtml: true,
                            content: '<div class="alert alert-warning">' + response.message + '</div>',
                            size: '',
                            showBottonCancel: false,
                            textActionCancel: '',
                            textAction: 'Aceptar'
                        };
                    }
                    if (__env.adaptative) {
                        this.messageMaterial(text);
                    } else {
                        this.messageResponse(options);
                    }

                    this.$state.go('home.login');
                    this.$state.reload();
                }).catch((reason) => {
                    if (__env.adaptative) {
                        this.messageMaterial(reason.message);
                    } else {
                        let options = {
                            title: 'Cambio de clave',
                            isHtml: true,
                            content: `<div class="alert alert-danger">${reason.message} </div>`,
                            size: '',
                            showBottonCancel: false,
                            textActionCancel: '',
                            textAction: 'Aceptar'
                        };
                        this.messageResponse(options);
                        this.loadingRpass = false;
                    }
                });
            } else {

                if (!this.loginDataForm.email) {
                    this.emailEmpty = true;
                }
                if (!this.captchaModel2) {
                    this.captchaEmpty = true;
                }
                this.loadingRpass = false;
            }

        }


    }

    messageMaterial(text) {
        var mdToast = this.$mdToast;
        this.$mdToast.show({
            hideDelay: 7000,
            controller: function () {
                this.closeToast = function () {
                    mdToast.hide();
                }

            },
            controllerAs: 'toast',
            template: '<md-toast>\n' +
                '  <span class="md-toast-text">' + text + '</span>\n' +
                '  <md-button ng-click="toast.closeToast()">\n' +
                '    Cerrar\n' +
                '  </md-button>\n' +
                '</md-toast>'
        });
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }

    cambiarSucursalVolumenItems(cartId, idCiudad, idUsuario) {
        this.CartService.getShippingMode(cartId).then(response => {
            if (response.modalidad) {
                this.setSucursalesPorModalidad(response, cartId, idCiudad, idUsuario);
            } else {
                this.obtenerSucursalSecundaria(cartId, idCiudad, idUsuario);
            }
        });
    }

    setSucursalesPorModalidad(response, cartId, idCiudad, idUsuario) {
        let data = {
            'userId': idUsuario,
            'ciudadId': idCiudad
        };
        let tipoModalidad = response.modalidad.tipo_modalidad;
        // Si la modalidad es recoge
        if (tipoModalidad == 0) {
            this.CartService.getSecondaryBranch(data).then(response => {
                let idSucursalSecundaria = response.listaSucursales[0].id;
                if (idSucursalSecundaria != null) {
                    this.setSucursalSecundariaRecogeEntrega(idSucursalSecundaria, idUsuario, cartId);
                }
            });
            this.CartService.updateDateCart(cartId).then(response => {
                return response;
            });
            // Si es a domicilio
        } else {
            this.CartService.getSecondaryBranch(data).then(response => {
                let idSucursalSecundaria = response.listaSucursales[0].id;
                let idCiudad = response.listaSucursales[0].ciudad_id;

                if (idCiudad != null && idSucursalSecundaria != null && cartId != null) {
                    this.CartService.updatePromiseCart(cartId, idSucursalSecundaria, idCiudad).then(response => {
                        let aplicaServicioDescargue = response.aplicaServicioDescargue;
                        if (idSucursalSecundaria != null) {
                            this.setSucursalSecundariaTipoDomicilio(idSucursalSecundaria, idUsuario, aplicaServicioDescargue, cartId);
                        }
                    });
                }
            });
        }
    }

    setSucursalSecundariaRecogeEntrega(idSucursal, userId, cartId) {

        let mensajeCambioSucursal = '';
        let mensajeCambioHorarioBodega = '';
        let allMessage = [];
        try {
            mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
            mensajeCambioHorarioBodega = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_HORARIO_BODEGA;
            allMessage.push(mensajeCambioSucursal);
            allMessage.push(mensajeCambioHorarioBodega);

        } catch (e) {
        }
        this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
            if (!response.error) {
                // Set the current client
                try {
                    let newCurrentClient = JSON.parse(global.localStorage.currentClient);
                    newCurrentClient.operatingCenter = response.branch;
                    newCurrentClient.seller = response.seller;
                    this.SessionService.put('currentClient', newCurrentClient);
                    this.SessionService.put('cartId', response.cartID);
                    this.$rootScope.$broadcast('actualizarHeader', response.branch);

                    this.SharedService.assignWarehouseBasketCode({ 'cartId': cartId }).then(response => {
                        if (!response.error) {
                            if (allMessage !== null) {
                                this.$state.go('home.salesHome');
                                this.$timeout(() => {
                                    this.$state.reload();
                                }, 500);
                                this.showModalAllMessage(allMessage);
                            }
                        }
                    });
                } catch (e) {
                }

            } else {
                console.log('Ocurrio un erro al cambiar la sucursal')
            }
        }).catch(reason => {
            this.state.saving = false;
            this.state.error = true;
        });
    }

    setSucursalSecundariaTipoDomicilio(idSucursal, userId, aplicaServicioDescargue, cartId) {

        let mensajeCambioSucursal = '';
        let mensajeDestinoNoDisponilble = '';
        let mensajeCambioPromesa = '';
        let allMessage = [];

        try {
            mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
            mensajeCambioPromesa = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_PROMESA;
            allMessage.push(mensajeCambioSucursal);
            allMessage.push(mensajeCambioPromesa);

            if (!aplicaServicioDescargue) {
                this.servicioDescargue = aplicaServicioDescargue;
                mensajeDestinoNoDisponilble = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_INFORMATITVO_DESTINOS_NO_DISPONIBLES;
                allMessage.push(mensajeDestinoNoDisponilble);
            }

        } catch (e) {
        }
        this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
            if (!response.error) {
                // Set the current client
                try {
                    let newCurrentClient = JSON.parse(global.localStorage.currentClient);
                    newCurrentClient.operatingCenter = response.branch;
                    newCurrentClient.seller = response.seller;
                    this.SessionService.put('currentClient', newCurrentClient);
                    this.SessionService.put('cartId', response.cartID);
                    this.$rootScope.$broadcast('actualizarHeader', response.branch);

                    this.SharedService.assignWarehouseBasketCode({ 'cartId': cartId }).then(response => {
                        if (!response.error) {

                            if (allMessage !== null) {
                                this.$state.go('home.salesHome');
                                this.$timeout(() => {
                                    this.$state.reload();
                                }, 500);
                                this.showModalAllMessage(allMessage);
                            }
                        }
                    });
                } catch (e) {
                }

            } else {
                console.log('ocurrio un error al cambiar de sucursal')
            }
        }).catch(reason => {
            this.state.saving = false;
            this.state.error = true;
        });
    }

    showModalAllMessage(allMesagge) {
        let contentDynamic = 'Se realizaron las siguientes modificaciones: </br>';

        for (let i = 0; i < allMesagge.length; i++) {
            contentDynamic += `
                                <ul><li>` + allMesagge[i] + `</li></ul>`;
        }

        if (contentDynamic != '') {
            let optionsMessage = {
                title: 'Actualización de precios',
                isHtml: true,
                content: contentDynamic,
                size: '',
                showBottonCancel: false,
                textActionCancel: '',
                textAction: 'Aceptar',
                backdrop: 'static'
            };

            let modalInstance = this.$uibModal.open({
                animation: true,
                template: modalConfirmation,
                controller: 'ModalResponseController',
                controllerAs: 'mdCtrl',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    modalOptions: () => optionsMessage
                }
            });
            modalInstance.result.then(() => {
            }).catch(() => {

            });
        }
    }

    obtenerSucursalSecundaria(cartId, idCiudad, idUsuario) {
        let data = {
            'userId': idUsuario,
            'ciudadId': idCiudad
        };
        // Si la modalidad es recoge 
        if (data != null) {
            this.CartService.getSecondaryBranch(data).then(response => {
                let idSucursalSecundaria = response.listaSucursales[0].id;
                if (idSucursalSecundaria != null) {
                    this.setSucursalSecundariaSinModalidad(idSucursalSecundaria, idUsuario, cartId);
                }
            });
            this.CartService.updateDateCart(cartId).then(response => {
                return response;
            });
        }
    }

    setSucursalSecundariaSinModalidad(idSucursal, userId, cartId) {

        let mensajeCambioSucursal = '';
        let allMessage = [];
        try {
            mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
            allMessage.push(mensajeCambioSucursal);
        } catch (e) {
        }
        this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
            if (!response.error) {
                // Set the current client
                try {
                    let newCurrentClient = JSON.parse(global.localStorage.currentClient);
                    newCurrentClient.operatingCenter = response.branch;
                    newCurrentClient.seller = response.seller;
                    this.SessionService.put('currentClient', newCurrentClient);
                    this.SessionService.put('cartId', response.cartID);

                    this.$rootScope.$broadcast('actualizarHeader', response.branch);
                    this.SharedService.assignWarehouseBasketCode({ 'cartId': cartId }).then(response => {
                        if (!response.error) {
                            if (allMessage !== null) {
                                this.$state.go('home.salesHome');
                                this.$timeout(() => {
                                    this.$state.reload();
                                }, 500);
                                this.showModalAllMessage(allMessage);
                            }
                        }
                    });
                } catch (e) {
                }

            } else {
                console.log('Ocurrio un erro al cambiar la sucursal')
            }
        }).catch(reason => {
            this.state.saving = false;
            this.state.error = true;
        });
    }
}

LoginController.$inject = inject;

export default LoginController;




/** WEBPACK FOOTER **
 ** ./www/components/login/login.controller.js
 **/